import { Position, Toaster } from '@blueprintjs/core';

export const AppToaster = Toaster.create({
  className: 'checkup-toaster',
  position: Position.BOTTOM,
});